import axios from 'axios';
import { getAuth } from 'firebase/auth'; // Firebase Auth import

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const RATING_API_BASE_URL = `${API_BASE_URL}/public/rating`;

class RatingService {

    // Token'ı almak için kullanacağımız yardımcı fonksiyon
    async getToken() {
        const auth = getAuth();
        const user = auth.currentUser;
        if (user) {
            return await user.getIdToken(); // Firebase'den token alıyoruz
        }
        return null;
    }



    async rating(ratingRequest) {
        return axios.post(`${RATING_API_BASE_URL}`, ratingRequest, {
        });
    }

}

export default new RatingService();
